var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "value": true,
      "width": "400"
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.showStatus
    }
  }), _c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', {
    staticClass: "pa-4"
  }, [_vm._v("Specify amount")]), (_vm.order.n_giftcard_recipients || 1) > 1 ? _c('v-card-subtitle', {
    staticClass: "mt-n5 px-4 pb-6"
  }, [_vm._v(" This gift card will be sent to " + _vm._s(_vm._f("pl")(_vm.order.n_giftcard_recipients, 'recipient')) + " ")]) : _vm._e(), _c('v-card-subtitle', {
    staticClass: "px-4 mt-0"
  }, [_c('v-card', {
    staticClass: "float-right ml-4 mb-1 gc-border",
    attrs: {
      "width": "100"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 337 / 213,
      "src": _vm.blob.giftcard.product_img
    }
  })], 1), _c('div', {
    staticClass: "overline short",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.blob.giftcard.product_name)
    }
  }), _c('giftcard-details', {
    attrs: {
      "src": _vm.blob.giftcard.src,
      "product-id": _vm.blob.giftcard.product_id
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('div', {
    staticClass: "px-4 pb-4",
    class: {
      'pt-4': _vm.blob.giftcard.allowed_values.fixed
    }
  }, [_c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return function () {
          if (_vm.stagedGiftcardAmtValid) {
            _vm.blob.giftcard.amt = _vm.stagedGiftcardAmt;
            _vm.$emit('input', false);
          }
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.stagedGiftcardAmtValid,
      callback: function ($$v) {
        _vm.stagedGiftcardAmtValid = $$v;
      },
      expression: "stagedGiftcardAmtValid"
    }
  }, [_c('giftcard-amount', {
    attrs: {
      "allowed-values": _vm.blob.giftcard.allowed_values,
      "cur": _vm.blob.giftcard.cur,
      "max": _vm.maxGiftcardValueRemaining
    },
    model: {
      value: _vm.stagedGiftcardAmt,
      callback: function ($$v) {
        _vm.stagedGiftcardAmt = $$v;
      },
      expression: "stagedGiftcardAmt"
    }
  })], 1)], 1), _vm.noAmtValid ? [_c('v-divider'), _c('v-card-text', {
    staticClass: "error--text font-italic pa-4"
  }, [_vm._v("Max gift card value is restricted to "), _c('currency', {
    attrs: {
      "code": _vm.blob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.maxGiftcardValue) + " – there are no valid values that can be assigned to this gift card. Please try a different one.")], 1)] : _vm._e(), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.stagedGiftcardAmtValid
    },
    on: {
      "click": function ($event) {
        _vm.blob.giftcard.amt = _vm.stagedGiftcardAmt;
        _vm.$emit('input', false);
      }
    }
  }, [_vm._v(" Save ")])], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }